import { WordCloudApi } from 'api/WordCloudApi';
import { apiClient } from 'container/apiClient';
import { wordCloudMapper } from 'container/wordCloudMapper';

export const wordCloudApi = new WordCloudApi(apiClient, wordCloudMapper);
